module.exports = __webpack_public_path__ + "img/phone-call.0f31ed8d.svg";